export const ANALYTICS_PAGE = '/analytics';
export const CLOUDFLARE_API_KB_ARTICLE_PAGE = 'https://support.cloudflare.com/hc/en-us/articles/200167836-Where-do-I-find-my-CloudFlare-API-key-';
export const CLOUDFLARE_FORGOT_PASSWORD_PAGE = 'https://cloudflare.com/a/forgot-password';
export const CLOUDFLARE_SIGNUP_PAGE = 'https://www.cloudflare.com/a/sign-up';
export const CLOUDFLARE_UPGRADE_PAGE = 'http://cloudflare.com/plans';
export const CLOUDFLARE_DASHBOARD_PAGE = 'http://cloudflare.com/a/overview/';
export const DOMAINS_OVERVIEW_PAGE = '/zones';
export const HOME_PAGE = '/home';
export const MORE_SETTINGS_PAGE = '/more-settings';
export const LOGIN_PAGE = '/login';
export const PERFORMANCE_PAGE = '/performance';
export const SECURITY_PAGE = '/security';
export const SIGN_UP_PAGE = '/sign-up';
export const SUPPORT_PAGE = 'https://support.cloudflare.com/hc/en-us/';
export const TERMS_AND_CONDITIONS_PAGE = 'https://www.cloudflare.com/terms';
export const PRIVACY_POLICY_PAGE = 'https://www.cloudflare.com/security-policy';
export const CLOUDFLARE_ACCOUNT_PAGE = 'https://www.cloudflare.com/a/account/my-account';